export default {
  engagementSpellCheckDictionaries(state) {
    return state.engagementSpellCheckDictionaries;
  },
};
